module.exports = __webpack_public_path__ + "img/prof4.6e9510c0.jpg";